import { useTranslation } from 'react-i18next';
import { useGetMediaSearch } from '@sendible/frontendv2/src/models/mediaSearch';
import { useComposeBoxContext } from '../../../composeBoxContext';
import { CommonMediaSearchModal } from '../CommonMediaSearchModal';

export const GiphyModal = () => {
  const { setIsGiphyModalOpen } = useComposeBoxContext();
  const { t } = useTranslation(['compose_box', 'common_terms']);
  const useSearchHook = (query: string) => useGetMediaSearch(query, 'Giphy');

  return (
    <CommonMediaSearchModal
      onClose={() => setIsGiphyModalOpen(false)}
      icon="giphy"
      label={t('giphy', { ns: 'common_terms' }) as string}
      searchLabel={t('search_gifs') as string}
      importButtonLabel={(count) => (count === 1 ? (t('import_gif') as string) : (t('import_gifs', { count }) as string))}
      useSearchHook={useSearchHook}
    />
  );
};
